<template>
  <div class="mainlogin_box">
    <div class="row">
      <div class="col-sm-7">
        <div class="loginimg">
          <img src="/static/img/login_img.png" class=" login logo" />
        </div>
      </div>
      <div class="col-sm-5">
        <div class="login_form">
          <h1>Administration Login</h1>
          <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
          </div>

          <div v-else>
            <div class="row"></div>

            <div v-if="accountActive">
              <!-- login form -->
              <vue-form
                :state="formstate"
                class="ui form loginForm row "
                @submit.prevent="login"
              >
                <validate
                  auto-label
                  class="form-group required-field"
                  :class="fieldClassName(formstate.email)"
                >
                  <div class="input-group">
                    <label>Email or Phone Number</label>
                    <input
                      class="form-control"
                      name="email"
                      required
                      placeholder="Enter email or phone number"
                      type="text"
                      v-model="email"
                    />
                    <field-messages
                      name="email"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required" v-if="!email">
                        Email or phone is a required field
                      </div>
                      <div slot="required" v-else>
                        Email or phone is a required field
                      </div>
                    </field-messages>
                  </div>
                </validate>

                <validate
                  auto-label
                  class="form-group required-field"
                  :class="fieldClassName(formstate.password)"
                >
                    <a class="fa fa-eye passwordView" role="button" v-on:click="showPassword"></a>
                  <div class="input-group">
                    <label>Password</label>
                    <input
                      class="form-control"
                      required
                      id="password"
                      name="password"
                      placeholder="Enter password"
                      type="password"
                      v-model="password"
                    />
                    <field-messages
                      name="password"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Password is a required field</div>
                    </field-messages>
                  </div>
                </validate>

                <div class="form-actions">
                  <button
                    type="submit"
                    :disabled="!(formstate.$dirty && formstate.$valid)"
                    v-bind:class="'btn btn-primary btn-lg ' + loading"
                  >
                    Login
                  </button>

                  <div style="margin-top: 15px;" class="app-links">
                   <a :href="driverAppUrl"><span class="c-pointer f-15">Download Driver App</span></a>
                    <a :href="surveyAppUrl" class="mt-10"><span class="c-pointer f-15">Download Survey App</span></a>
                  </div>
                </div>

                <!-- <div class="d-flex justify-center">
                  <div class="app-links">
                    <a :href="driverAppUrl"><span class="c-pointer f-15">Download Driver App</span></a>
                    <a :href="surveyAppUrl" class="mt-10"><span class="c-pointer f-15">Download Survey App</span></a>
                  </div>
                </div> -->
              </vue-form>

              
              

              <!-- <div>
    <hr />
    <h3>Or</h3>
    <div style="margin-top: 15px;">
      <button @click="$msal.signIn()" v-bind:class="'btn btn-primary btn-lg ' + loading">Waste Management
        Employee</button> -->
              <!-- <a class="btn btn-block btn-social btn-facebook" :href="loginFacebookURI">
          <span class="fa fa-facebook"></span> Sign in with Facebook
        </a>
        <a class="btn btn-block btn-social btn-google" :href="loginGoogleURI">
          <span class="fa fa-google"></span> Sign in with Google
        </a>
        <a class="btn btn-block btn-social btn-github" :href="loginGithubURI">
          <span class="fa fa-github"></span> Sign in with GitHub
        </a>-->
              <!-- </div>
  </div> -->
            </div>

            <div
              v-if="!accountActive && !emailSent"
              class="text-center col-md-4 col-md-offset-4"
            >
              <vue-form
                class="ui form"
                :state="formstate"
                @submit.prevent="sendActivationEmail"
              >
                <validate
                  auto-label
                  :class="fieldClassName(formstate.email)"
                  :debounce="250"
                  :custom="{ email: emailValidator }"
                >
                  <vue-form-input
                    class="input-group"
                    required
                    v-model="email"
                    :formstate="formstate"
                    :type="'email'"
                    :name="'email'"
                    :placeholder="'Email'"
                    :messages="{
                      required: 'This field is required',
                      email: 'Please input a valid email',
                    }"
                  >
                    <span class="input-group-addon">
                      <i class="fa fa-envelope"></i>
                    </span>
                  </vue-form-input>
                </validate>

                <div class="content-centered">
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg"
                    style="margin-top: 15px;"
                    :disabled="formstate.$invalid"
                  >
                    Send Activation Email
                  </button>
                </div>
              </vue-form>
            </div>

            <div v-if="!accountActive && emailSent" class="content-centered">
              <router-link to="/login">
                <button class="btn btn-primary" style="margin-top: 15px;">
                  Proceed to Login
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authService, formService } from "../../../services";
import config from "../../../config";
import { msalMixin } from "vue-msal";
import { UserAgentApplication } from "msal";

var crypto = require("crypto");

export default {
  name: "Login",
  data() {
    return {
      passwordIncorrect: {},
      loginErrorMsg: {},
      loading: false,
      formstate: {},
      flash: false,
      flashType: null,
      flashMessage: "",
      accountActive: true,
      emailSent: false,
      email: '',
      phone:'',
      reg: '^[A-Za-z0-9._%+-]+@think-gas.com$',
      password: '',
      driverAppUrl:config.driverApkUrl,
      surveyAppUrl:config.surveyApkUrl,
      entryPoint:
        "https://login.microsoftonline.com/1a63eded-aece-4b7f-a3d7-39828b274d9b/oauth2/v2.0/authorize?client_id=1b323a04-1682-4ec3-ae22-e39d3bf6f6ff&scope=openid%20profile&redirect_uri=https://jma-uat.think-gas.com&client-request-id=c6929d2d-b20e-421d-88f5-c7efb2183b9d&response_mode=fragment&response_type=code&x-client-SKU=msal.js.browser&x-client-VER=2.3.1&x-client-OS=&x-client-CPU=&client_info=1&code_challenge=XU0nWCx28IU6luV8FBTZP5jrmo_bJXviirh5c7d1fyg&code_challenge_method=S256&nonce=72c9b7f1-3d8a-4cf9-a62e-918faad8dc74&state=eyJpZCI6Ijk2ZDljNTgwLTM2NzYtNGNiMS05OTVjLTU0ZWVjZWJiMWRkYiIsInRzIjoxNjMzNDE3NzMyLCJtZXRhIjp7ImludGVyYWN0aW9uVHlwZSI6InBvcHVwIn19",
    };
  },
  mixins: [msalMixin],
  computed: {
    loginFacebookURI() {
      return config.serverURI + "/auth/facebook";
    },
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    emailValidator: formService.emailValidator,

    showPassword(){
        let x = document.getElementById("password");
        x.type === "password" ? x.type = "text" : x.type ="password";
    },

    login() {
      var { email, password } = this;
      const string = this.email;
      if (email.includes("@")) {
        authService
          .login({ email, password })
          .then((response) => {
            this.loading = false;
            // this.$snotify.success('The user has been logged in successfully.');
            this.$router.push("/");
          })
          // .catch(error => {
          //   this.loading = false;
          //   console.error('Login.login-error:', error);
          //   this.flash = true;
          //   this.flashType = 'error';
          //    this.flashMessage = error.data.message;
          //    this.loginErrorMsg = error.data.validation.keys[0];

          // });
          .catch((error) => {
            this.loading = false;
            if (error.data && error.data.message) {
              if (
                error.data.message ==
                'child "phone" fails because ["phone" is not allowed to be empty]'
              ) {
                error.data.message = "Email / Phone is not allowed to be empty";
                this.$snotify.error(error.data.message, "Error!");
              } else if (
                error.data.message ==
                'child "password" fails because ["password" is not allowed to be empty]'
              ) {
                error.data.message = "Password is not allowed to be empty";
                this.$snotify.error(error.data.message, "Error!");
              } else if (
                error.data.message ==
                "Login permissions denied. Please contact City admin."
              ) {
                error.data.message = "Please contact administration.";
                this.$snotify.error(error.data.message, "Error!");
              } else {
                this.$snotify.error(error.data.message, "Error!");
              }
            } else {
              this.$snotify.error("Login Failed", "Error");
            }
          });
      } else {
        let phone = email;
        authService
          .login({ phone, password })
          .then((response) => {
            this.loading = false;
            this.$snotify.success("The user has been logged in successfully.");
            this.$router.push("/");
          })
          // .catch(error => {
          //   this.loading = false;
          //   console.error('Login.login-error:', error);
          //   this.flash = true;
          //   this.flashType = 'error';
          //   this.flashMessage = error.data.message;
          //   this.passwordIncorrect = error.data.message
          //   this.loginErrorMsg = error.data.validation.keys[0];

          // });
          .catch((error) => {
            this.loading = false;
            if (error.data && error.data.message) {
              if (
                error.data.message ==
                'child "phone" fails because ["phone" is not allowed to be empty]'
              ) {
                error.data.message = "Email / Phone is not allowed to be empty";
                this.$snotify.error(error.data.message, "Error!");
              } else {
                this.$snotify.error(error.data.message, "Error!");
              }
            } else {
              this.$snotify.error("Login failed", "Error!");
            }
          });
      }
    },

    sendActivationEmail() {
      this.loading = true;
      authService
        .sendActivationEmail(this.email)
        .then((response) => {
          this.loading = false;
          this.emailSent = true;
          this.flash = true;
          this.flashType = "success";
          this.flashMessage =
            "Message sent. Please check your email for an account activation link.";
        })
        .catch((error) => {
          console.error("Login.sendActivationEmail-error:", error);
          this.loading = false;
          this.flash = true;
          this.flashType = "error";
          // NOTE: For more secure applications, the server should respond with a success even if the user isn't found
          // since this reveals the existence of an account. For more information, refer to the links below:
          // https://postmarkapp.com/guides/password-reset-email-best-practices
          // https://security.stackexchange.com/questions/40694/disclose-to-user-if-account-exists
          if (error.data.message === "User not found.") {
            this.flashMessage = "No account was found with that email.";
          } else {
            this.flashMessage =
              "There was an error sending the email. " +
              "Please try again or contact us if you continue to have trouble creating an account.";
          }
        });
    },
  },
  created() {
    this.email = this.$route.query.email || "";
    this.password = this.$route.query.password || "";
  },
};
</script>

<style lang="scss">
html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}

.container {
  display: flex;
  flex-direction: row;
}

// .container-table {
//   display: flex;
//   color: white;
//   // display: flex;
//   // flex-direction: row;
//   // justify-content: flex-end;
//   // margin-right: -25rem;
// }

.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.vertical-20p {
  padding-top: 20%;
}

.vertical-10p {
  padding-top: 10%;
}

.login.logo {
  width: 100%;
  height: 100vh;
  padding: 0;
  object-fit: cover;
}
.login_form {
  padding-right: 65px;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: auto;
  text-align: left;
  width: 100%;
}
.loginForm {
  padding-top: 30px;
}
.loginForm .input-group input {
  background: transparent;
  border: 2px solid #ddd;
  height: 4rem;
}
.loginForm .input-group input:focus {
  background: transparent;
}
.form-actions {
  text-align: center;
}
.loginForm .form-actions button {
  background: #35A2FE;
  padding: 6px 20px;
  border-radius: 0;
  border: 0;
  margin-top: 10px;
  width: 200px;
}
.loginForm .form-actions button:hover {
  background: #35A2FE;
}
.form-actions a {
  font-weight: 600;
}
.loginForm .input-group label {
  font-size: 16px;
}
.input-group input {
  height: 4em;
}

.btn-outline:hover {
  color: #333333;
}
.mainlogin_box {
  background: #fff;
}
.login_form h1 {
  font-size: 22px;
  font-weight: 600;
}
.passwordView {
  color: #35A2FE;
  font-size: large;
  position: absolute;
  left: 90%;
  top: 52%;
  z-index: 4;
}
</style>



// WEBPACK FOOTER //
// Login.vue?0166756b